import { LANDING_AMPLITUDE_EVENTS, LOCAL_STORAGE_KEYS } from '@/constants';
import { LANDINGS, type LandingTools } from '../aiToolLandings';
import { tryLiftConfig } from './tryLiftConfig';

export const landingToolsConfig: LandingTools = {
	id: 'tools',
	translationLocale: 'tools',
	hero: {
		title: 'heroData_title',
		buttonText1: 'heroData_buttonAll',
		buttonText2: 'heroData_buttonAITools',
		buttonText3: 'heroData_buttonImageEdit',
		tabs: [
			{
				id: 'all',
				title: 'heroData_tabs_tab1Title',
			},
			{
				id: 'enhance',
				title: 'heroData_tabs_tab2Title',
				emoji: '🌟',
			},
			{
				id: 'generate',
				title: 'heroData_tabs_tab3Title',
				emoji: '🎨',
			},
			{
				id: 'edit',
				title: 'heroData_tabs_tab4Title',
				emoji: '✏️️',
			},
			{
				id: 'portrait',
				title: 'heroData_tabs_tab5Title',
				emoji: '💃🏻',
			},
			{
				id: 'utility',
				title: 'heroData_tabs_tab6Title',
				emoji: '🧰',
			},
			{
				id: 'search',
				title: 'heroData_tabs_tab7Title',
				emoji: '🔎',
			},
		],
		toolsListing: LANDINGS,
		searchInputPlaceholder: 'heroData_searchInputPlaceholder',
		nothingFound1: 'heroData_nothingFound1',
		nothingFound2: 'heroData_nothingFound2',
	},
	faq: {
		title: 'faqData_mainTitle',
		buttonText: 'getStarted',
		list: [
			{
				title: 'faqData_title1',
				subtitle: 'faqData_subtitle1',
			},
			{
				title: 'faqData_title2',
				subtitle: 'faqData_subtitle2',
			},
			{
				title: 'faqData_title3',
				subtitle: 'faqData_subtitle3',
			},
			{
				title: 'faqData_title4',
				subtitle: 'faqData_subtitle4',
			},
		],
	},
	tryLift: {
		...tryLiftConfig,
	},
	analytics: {
		scrolledPercentName: LOCAL_STORAGE_KEYS.ALL_TOOLS_SCROLLED_POINTS,
		eventPropertyType: LANDING_AMPLITUDE_EVENTS.ALL_TOOLS,
		galleryContext: LANDING_AMPLITUDE_EVENTS.ALL_TOOLS_LANDING,
	},
};
